import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { DocumentTemplateCategorySchema } from '../identity/document-templates.schemas';

/** Ids only on the payload (ADR 0015 §PII): the name and the text are not carried. */
export const DocumentTemplateChangedPayloadSchema = z.object({
  documentTemplateId: z.uuid(),
  workspaceId: z.uuid(),
  category: DocumentTemplateCategorySchema,
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type DocumentTemplateChangedPayload = z.infer<typeof DocumentTemplateChangedPayloadSchema>;
